import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';
import Loader from 'components/Loader';
// import Breadcrumbs from 'components/@extended/Breadcrumbs';
// import AuthGuard from 'utils/route-guard/AuthGuard';
// import navigation from 'menu-items';
import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import { RightOutlined } from '@ant-design/icons';

// ==============================|| MAIN LAYOUT ||============================== //

export default injectIntl(function DashboardLayout({ intl }: any) {
  const location = useLocation();
  const { menuMasterLoading } = useGetMenuMaster();
  const matchDownXL = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const navigate = useNavigate();

  const { container, miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const currentLocation = location.pathname;
  const currentLocationArray = currentLocation.split('/');
  // set media wise responsive drawer

  const handleLocation = (customLocation: any) => {
    if (customLocation && Array.isArray(customLocation)) {
      // Join array elements with a '/' separator and prepend it with '/'
      const url = `${customLocation.join('/')}`;
      console.log(url);
      navigate(`${url}`);
    }
  };

  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!matchDownXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    // <AuthGuard>
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}

      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
        <Container
          maxWidth={false}
          sx={{
            ...(container && { px: { xs: 0, sm: 2 } }),
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} /> */}
          <Box display="flex" flexWrap="nowrap" alignItems="center" marginBottom={2}>
            {currentLocationArray
              .filter((location: any) => location.trim() !== '') // Filter out empty values
              .map((location: any, index: number, filteredArray: any[]) => {
                location = decodeURIComponent(location);
                const locationName = location.replaceAll('%20', ' ');
                const locationKey = location.trim().replace(/\s+/g, '-');

                // Try translating the location name, fallback to default if not found
                const translatedLocation = intl.messages[locationKey] || locationName;

                return index < filteredArray.length - 1 ? (
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    textTransform="capitalize"
                    key={index}
                    sx={{
                      display: 'inline',
                      marginRight: '0.5rem',
                      '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }
                    }}
                    onClick={() => handleLocation(filteredArray.slice(0, index + 1))}
                  >
                    {translatedLocation}
                    <RightOutlined style={{ marginLeft: '0.5rem' }} />
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    textTransform="capitalize"
                    key={index}
                    sx={{
                      display: 'inline'
                    }}
                  >
                    {translatedLocation}
                  </Typography>
                );
              })}
          </Box>
          <Outlet />
          <Footer />
        </Container>
      </Box>
    </Box>
    // </AuthGuard>
  );
});
